import * as React from 'react';
import * as Exceljs from '../../actions/ExportToExcel.js';
import { EmailControl } from './../sharedcomponents/EmailControl';
import { PopupWindow } from './../sharedcomponents/PopupWindow';
import Workbook from 'react-excel-workbook';
import $ from 'jquery';
var Excel = Exceljs.default;



export interface ToolBarState {
    exportFields: ExportFields;
    DisableVCOption: boolean;
    EnableVCCheckBox: boolean;
    DisableVCCheckBoxOption: boolean;
    DisableVCDropDown: boolean;
    DropDownVCData: server.VesselInformation[];
    SelectedVCData: server.VesselInformation;
    SelectedVesselId: number;
    excelData: any[];
    headerData: any[];
    isDownload: boolean;
    excelGridData: any[];
    formName: string;
    fileTitle: string;
    sheetInfo: any;
}
class ExportFields {
    ExportData: string;
}

var self;
const emptyExportFields: ExportFields = { ExportData: '' };

export class GridToolBarDrysPopups extends React.Component<any, ToolBarState> {
    constructor(props: any) {
        super(props);
        this.state = {
            exportFields: emptyExportFields,
            DisableVCOption: false,
            DisableVCCheckBoxOption: false,
            EnableVCCheckBox: false,
            DisableVCDropDown: false,
            DropDownVCData: [],
            SelectedVCData: null,
            SelectedVesselId: 0,
            excelData: [],
            headerData: [],
            isDownload: false,
            excelGridData: this.props.gridData,
            formName: this.props.formName,
            fileTitle: this.props.formName, sheetInfo: ''
        };

        self = this;
    }

    componentDidMount() {
        this.renderSheets();
    }

    componentWillReceiveProps(nextProps: any) {
        
    }

    RefreshData() {
        this.props.refreshGrid();
    }

    ExportToExcel() {
        var arrData;
        if (self.props.gridData != undefined && self.props.gridData != null && self.props.gridData.length > 0) {
            arrData = typeof self.props.gridData != 'object' ? JSON.parse(self.props.gridData) : self.props.gridData;
            var r = self.props.colDefs;
            var uri;
            var sheetData = { HeaderData: [], ColumnData: [] };
            $("#globalLoader").show();
            if (self.props.parentchild == 'P') {
                uri = Excel.InitializeExportParentToXLSX(arrData, r, this.props.formName);
                self.state.exportFields.ExportData = JSON.stringify(uri);
            } else {
                uri = Excel.InitializeExportChildToXLSX(arrData, r, this.props.formName);
                self.state.exportFields.ExportData = JSON.stringify(uri);
            }

            sheetData = Excel.ConvertCSVToJSon(uri);
            self.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => self.downloadExcel(self.props.formName, true));
        }
        else {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "No Data to Export.");
        }
    }

    closepopupModel() {
        $('#PopupEmailTo').hide();
    }

    EmailTo() {
        $('#PopupEmailTo').show();
    }

   
  

    renderSheets() {
        this.setState({ sheetInfo: this.generateSheetInfo() }, () => this.checkToFileDownload());
    }

    checkToFileDownload() {
        if (this.state.isDownload) {
            $('#btnDownloadPopUpExcel').click();
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            this.setState({ isDownload: false });
        }
    }

    getSheetInfo(headerName: string) {
        var headerInfo = headerName.replace(/\s+/g, '');
        var removeDotInHeader = headerInfo.split('.').join('');
        var removeNInHeader = removeDotInHeader.replace('/n', '');
        var removeHashInHeader = removeNInHeader.replace('#', '');
        var removeUTCInHeader = removeHashInHeader.replace('(UTC)', '');
        var finalHeaderColumn = removeUTCInHeader.replace('(°C)', '');
        return <Workbook.Column label={headerName} value={finalHeaderColumn} />;
    }

    generateSheetInfo() {
        var columnInfo = [];
        if (this.state.headerData != null && this.state.headerData.length > 0) {
            $.each(this.state.headerData, function (i, iVal) {
                var sheetObject = self.getSheetInfo(iVal.headerName);
                columnInfo.push(sheetObject);
            });
        }

        return <Workbook.Sheet data={this.state.excelData} name="Sheet1">
            {columnInfo}
        </Workbook.Sheet>;
    }

    downloadExcel(formName: string, isFileDownload: boolean) {
        var currentDate = new Date();
        self.setState({
            fileTitle: formName + currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds(),
            isDownload: isFileDownload
        }, () => self.renderSheets());
    }

    static applySheetData(sheetData: any, formName: string) {
        self.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => self.downloadExcel(formName == '' ? self.props.formName : formName, true));
    }

    public render() {
        return <div>
            <div className='aggrid-icons-bg'>
                <div className="btn-group aggrid-icons">
                    <button type="button" id="RefreshPopUpBtn" title='Refresh' className="btn btn-outline-secondary" onClick={this.RefreshData.bind(this)} ><span className='fas fa-sync-alt'></span></button>
                    <button type="button" id="ExcelPopUpBtn" title='Export to Excel' className="btn btn-outline-secondary" onClick={this.ExportToExcel.bind(this)}><span className='far fa-file-excel'></span></button>
                    <button type="button" id="EmailPopUpBtn" title='Email to' className="btn btn-outline-secondary" onClick={this.EmailTo.bind(this)}><span className='fa fa-envelope'></span></button>
                    <Workbook filename={this.state.fileTitle + ".xlsx"} element={<button id="btnDownloadPopUpExcel" className="btn-lg btn btn-outline-secondary d-none"></button>}>
                        {this.state.sheetInfo}
                    </Workbook>
                </div>          
            </div>
            <div className="modal" role="dialog" id="PopupEmailTo">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Email</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closepopupModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                           
                        </div>
                        <div className="modal-body">
                            <EmailControl reeferStatusResult={this.props.gridData} columnDefinition={this.props.colDefs} parentchild={this.props.parentchild} formname={this.props.formName} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}